<template>
    <nav class="navbar navbar-default navbar-fixed-top" color-on-scroll="100">
        <div class="container">
            <div class="navbar-header">
                <button 
                    id="menu-toggle" 
                    type="button" 
                    class="navbar-toggle" 
                    data-toggle="collapse" 
                    data-target="#example">
                        <span class="sr-only">Toggle navigation</span>
                        <span class="icon-bar bar1"></span>
                        <span class="icon-bar bar2"></span>
                        <span class="icon-bar bar3"></span>
                </button>

                <router-link :to="{ name: 'home'}" class="navbar-brand">
                    <img src="../../assets/logowithname.png">
                </router-link>
            </div>

            <div class="collapse navbar-collapse">
                <ul class="nav navbar-nav navbar-right navbar-uppercase">
                    <router-link :to="{ name: 'restaurants' }" tag="li" active-class="active">
                        <a>Restaurants</a>
                    </router-link>

                    <router-link :to="{ name: 'orders' }" tag="li" active-class="active" 
                        v-if="isUserLoggedIn">
                        <a>My Orders</a>
                    </router-link>

                    <router-link :to="{ name: 'location' }" tag="li" active-class="active">
                        <a>Change Location</a>
                    </router-link>

                    <router-link :to="{ name: 'privacy' }" tag="li" active-class="active">
                        <a>Privacy</a>
                    </router-link>

                    <template v-if="!isUserLoggedIn">
                        <li>
                            <a @click.prevent="loginUser">Log In</a>
                        </li>

                        <li>
                            <a @click.prevent="signupUser">Sign Up</a>
                        </li>
                    </template>

                    <template v-else>
                        <router-link :to="{ name: 'my_account' }" tag="li" active-class="active">
                            <a>My Account</a>
                        </router-link>

                        <li>
                            <a @click.prevent="logoutUser">Log Out</a>
                        </li>
                    </template>

                    <router-link :to="{ name: 'basket' }" tag="li" active-class="active">
                        <a href="" class="text-info">
                            <i class="fa fa-shopping-basket"></i>
                            <span class="badge">{{ basketCount }}</span>
                        </a>
                    </router-link>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex';

	export default {
		computed: {
			...mapGetters({
				pageTitle: 'pageTitle',
                isUserLoggedIn: 'User/isLoggedIn',
                basketCount: 'Basket/getCount'
            })
		},

		methods: {
            ...mapActions({
                showLoginModal: 'User/setShowLogin',
                showSignupModal: 'User/setShowSignup',
                showResetModal: 'User/setShowReset'
            }),

            /**
             * Show login modal.
             * 
             * @return null
             */
            loginUser() {
                this.showLoginModal(true);
            },

            /**
             * Show reset modal
             *
             * @return null
             */
            initReset() {
                this.showResetModal(true);
            },

            /**
             * Show sign up modal.
             * 
             * @return null
             */
            signupUser() {
                this.showSignupModal(true);
            },

            /**
             * Logged out the user by emitting
             * the logout event.
             * 
             * @return null
             */
			logoutUser() {
				this.$emit('logout');
			}
		}
	}
</script>

<style scoped>
	li {
		cursor: pointer;
	}

    .navbar-collapse > ul > li:not(:last-child) > a {
        color: #ffa725;
        font-weight: bold;
    }

    .navbar-brand img {
        height: 25px;
    }

    .badge {
        position: absolute;
        top: -2px;
        right: 8px;
        font-size: 12px;
        padding: 3px;
        border-radius: 30px;
        background-color: #00abc0;
    }

    @media (max-width: 768px) {
        .badge {
            top: 10px;
            left: 13px;
            right: unset;
        }
    }
</style>


// WEBPACK FOOTER //
// Header.vue?d877aad6